import { LessonDto, LocalizedProperty, State } from "../../interfaces";
import {
  CreateFlashCardRequest,
  FlashCardDto,
  UpdateFlashCardRequest,
} from "../../interfaces/flash-card";
import {
  CreateMediaError,
  UploadAndCreateFlashCardResponse,
} from "../../interfaces/media";
import { CreateMediaProgress } from "../../interfaces/media/create-media-progress.dto";
import { Paginated } from "../../models";
import {
  ADD_FLASH_CARD,
  ADD_FLASH_CARD_ERROR,
  ADD_FLASH_CARD_SUCCESS,
  ActionTypes,
  DELETE_ALL_FLASH_CARD,
  DELETE_ALL_FLASH_CARD_CONSENT,
  DELETE_ALL_FLASH_CARD_ERROR,
  DELETE_ALL_FLASH_CARD_SUCCESS,
  DELETE_FLASH_CARD,
  DELETE_FLASH_CARD_CONSENT,
  DELETE_FLASH_CARD_ERROR,
  DELETE_FLASH_CARD_SUCCESS,
  GET_FLASH_CARD,
  GET_FLASH_CARDS,
  GET_FLASH_CARDS_BY_LESSON,
  GET_FLASH_CARDS_BY_LESSON_ERROR,
  GET_FLASH_CARDS_BY_LESSON_SUCCESS,
  GET_FLASH_CARDS_ERROR,
  GET_FLASH_CARDS_SUCCESS,
  GET_FLASH_CARD_ERROR,
  GET_FLASH_CARD_SUCCESS,
  REMOVE_UPLOADED_FLASH_CARD_IMAGE,
  TOGGLE_ADD_EDIT_FLASH_CARD_MODAL,
  TOGGLE_FLASH_CARD_STATE,
  TOGGLE_FLASH_CARD_STATE_ERROR,
  TOGGLE_FLASH_CARD_STATE_SUCCESS,
  UPDATE_FLASH_CARD,
  UPDATE_FLASH_CARD_ERROR,
  UPDATE_FLASH_CARD_SUCCESS,
  UPLOAD_AND_CREATE_FLASH_CARD,
  UPLOAD_AND_CREATE_FLASH_CARD_ERROR,
  UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS,
  UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS,
  UPLOAD_FLASH_CARD_IMAGE,
  UPLOAD_FLASH_CARD_IMAGE_ERROR,
  UPLOAD_FLASH_CARD_IMAGE_SUCCESS,
} from "./actionTypes";

export class FlashCardState {
  flashCards!: State<Paginated<FlashCardDto[]>>;
  flashCardByLesson!: State<FlashCardDto[]>;
  flashCard!: State<FlashCardDto>;
  addFlashCard!: State<CreateFlashCardRequest>;
  updateFlashCard!: State<UpdateFlashCardRequest>;
  deleteFlashCard!: State<any>;
  uploadFlashCardImage: State<File>;
  deleteAllFlashCardByLessonId!: State<any>;
  toggleFlashCardState!: any;
  uploadAndCreateFlashCard!: State<any>[];
  constructor() {
    this.flashCards = {
      loading: false,
      error: null,
      success: false,
    };
    this.flashCardByLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.flashCard = {
      loading: false,
      error: null,
      success: false,
    };
    this.addFlashCard = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateFlashCard = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteFlashCard = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadFlashCardImage = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteAllFlashCardByLessonId = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleFlashCardState = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadAndCreateFlashCard = [];
  }
}

const initialState: FlashCardState = new FlashCardState();

export const flashCard = (
  state: FlashCardState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_FLASH_CARDS:
      state = {
        ...state,
        flashCards: {
          ...state.flashCards,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_FLASH_CARDS_SUCCESS:
      state = {
        ...state,
        flashCards: {
          ...state.flashCards,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_FLASH_CARDS_ERROR:
      state = {
        ...state,
        flashCards: {
          ...state.flashCards,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_FLASH_CARDS_BY_LESSON:
      state = {
        ...state,
        flashCardByLesson: {
          ...state.flashCardByLesson,
          loading: true,
          success: false,
          error: null,
        },
        flashCard: {
          ...state.flashCard,
          response: undefined,
        },
      };
      break;
    case GET_FLASH_CARDS_BY_LESSON_SUCCESS:
      state = {
        ...state,
        flashCardByLesson: {
          ...state.flashCardByLesson,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_FLASH_CARDS_BY_LESSON_ERROR:
      state = {
        ...state,
        flashCardByLesson: {
          ...state.flashCardByLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_FLASH_CARD:
      state = {
        ...state,
        flashCard: {
          ...state.flashCard,
          loading: true,
          success: false,
          error: null,
        },
        addFlashCard: {
          ...state.addFlashCard,
          loading: false,
          success: false,
          error: null,
        },
        updateFlashCard: {
          ...state.updateFlashCard,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_FLASH_CARD_SUCCESS:
      state = {
        ...state,
        flashCard: {
          ...state.flashCard,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_FLASH_CARD_ERROR:
      state = {
        ...state,
        flashCard: {
          ...state.flashCard,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_FLASH_CARD:
      state = {
        ...state,
        addFlashCard: {
          ...state.addFlashCard,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_FLASH_CARD_SUCCESS:
      state = {
        ...state,
        addFlashCard: {
          ...state.addFlashCard,
          loading: false,
          error: null,
          success: true,
        },
        flashCardByLesson: {
          ...state.flashCardByLesson,
          response: [
            action.payload,
            ...(state.flashCardByLesson.response as FlashCardDto[]),
          ],
        },
      };
      break;
    case ADD_FLASH_CARD_ERROR:
      state = {
        ...state,
        addFlashCard: {
          ...state.addFlashCard,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_FLASH_CARD:
      state = {
        ...state,
        updateFlashCard: {
          ...state.updateFlashCard,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_FLASH_CARD_SUCCESS: {
      const updatedItem = action.payload;
      const indexToUpdate: number | undefined =
        state.flashCardByLesson.response?.findIndex(
          (item) => item.id == updatedItem.id
        );
      const updatedItems = [
        ...(state.flashCardByLesson.response as FlashCardDto[]),
      ];
      if (indexToUpdate !== undefined && Number(indexToUpdate) >= 0) {
        updatedItems[indexToUpdate] = updatedItem;
      }
      state = {
        ...state,
        updateFlashCard: {
          ...state.updateFlashCard,
          loading: false,
          error: null,
          success: true,
        },
        flashCardByLesson: {
          ...state.flashCardByLesson,
          response: [...updatedItems],
        },
      };
      break;
    }
    case UPDATE_FLASH_CARD_ERROR:
      state = {
        ...state,
        updateFlashCard: {
          ...state.updateFlashCard,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_FLASH_CARD_CONSENT:
      state = {
        ...state,
        deleteFlashCard: {
          ...state.deleteFlashCard,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_FLASH_CARD:
      state = {
        ...state,
        deleteFlashCard: {
          ...state.deleteFlashCard,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_FLASH_CARD_SUCCESS:
      state = {
        ...state,
        deleteFlashCard: {
          ...state.deleteFlashCard,
          loading: false,
          error: null,
          success: true,
        },
        flashCardByLesson: {
          ...state.flashCardByLesson,
          loading: false,
          error: null,
          success: false,
          response: state.flashCardByLesson.response?.filter(
            (item) => item.id !== action.payload
          ),
        },
      };
      break;
    case DELETE_FLASH_CARD_ERROR:
      state = {
        ...state,
        deleteFlashCard: {
          ...state.deleteFlashCard,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_FLASH_CARD_IMAGE:
      state = {
        ...state,
        uploadFlashCardImage: {
          ...state.uploadFlashCardImage,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_FLASH_CARD_IMAGE_SUCCESS:
      state = {
        ...state,
        uploadFlashCardImage: {
          ...state.uploadFlashCardImage,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        flashCard: {
          ...state.flashCard,
          response: {
            answer: state.flashCard.response?.answer as LocalizedProperty,
            image: action.payload,
            lesson: state.flashCard.response?.lesson as LessonDto,
            content: state.flashCard.response?.content as LocalizedProperty,
            createdAt: state.flashCard.response?.createdAt as Date,
            createdBy: state.flashCard.response?.createdBy as string,
            deletedAt: state.flashCard.response?.deletedAt as Date,
            deletedBy: state.flashCard.response?.deletedBy as string,
            id: state.flashCard.response?.id as string,
            isActive: state.flashCard.response?.isActive as boolean,
            modifiedAt: state.flashCard.response?.modifiedAt as Date,
            modifiedBy: state.flashCard.response?.modifiedBy as string,
          },
        },
      };
      break;
    case UPLOAD_FLASH_CARD_IMAGE_ERROR:
      state = {
        ...state,
        uploadFlashCardImage: {
          ...state.uploadFlashCardImage,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_ADD_EDIT_FLASH_CARD_MODAL:
      state = {
        ...state,
        flashCard: {
          ...state.flashCard,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
        uploadFlashCardImage: {
          ...state.uploadFlashCardImage,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case DELETE_ALL_FLASH_CARD_CONSENT:
      state = {
        ...state,
        deleteAllFlashCardByLessonId: {
          ...state.deleteAllFlashCardByLessonId,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_ALL_FLASH_CARD:
      state = {
        ...state,
        deleteAllFlashCardByLessonId: {
          ...state.deleteAllFlashCardByLessonId,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_ALL_FLASH_CARD_SUCCESS:
      state = {
        ...state,
        deleteAllFlashCardByLessonId: {
          ...state.deleteAllFlashCardByLessonId,
          loading: false,
          error: null,
          success: true,
        },
        flashCardByLesson: {
          ...state.flashCardByLesson,
          loading: false,
          error: null,
          success: false,
          response: [],
        },
      };
      break;
    case DELETE_ALL_FLASH_CARD_ERROR:
      state = {
        ...state,
        deleteAllFlashCardByLessonId: {
          ...state.deleteAllFlashCardByLessonId,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_FLASH_CARD_STATE:
      state = {
        ...state,
        toggleFlashCardState: {
          ...state.toggleFlashCardState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_FLASH_CARD_STATE_SUCCESS:
      state = {
        ...state,
        toggleFlashCardState: {
          ...state.toggleFlashCardState,
          loading: false,
          error: null,
          success: true,
        },
        flashCardByLesson: {
          ...state.flashCardByLesson,
          response: state.flashCardByLesson?.response?.map(
            (flashCard: FlashCardDto) => {
              if (flashCard.id == action.payload.id)
                return { ...flashCard, isActive: !flashCard.isActive };
              return flashCard;
            }
          ),
        },
      };
      break;
    case TOGGLE_FLASH_CARD_STATE_ERROR:
      state = {
        ...state,
        toggleFlashCardState: {
          ...state.toggleFlashCardState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_AND_CREATE_FLASH_CARD:
      const updatedFlashCards = state.uploadAndCreateFlashCard.map((item) =>
        item.localId === action.payload.localId
          ? {
              ...item,
              loading: true,
              success: false,
              error: null,
              progress: 0,
              response: null,
            }
          : item
      );
      const flashCardExists = updatedFlashCards.some(
        (item) => item.localId === action.payload.localId
      );
      state = {
        ...state,
        uploadAndCreateFlashCard: flashCardExists
          ? updatedFlashCards // Replace the existing item
          : [
              ...updatedFlashCards,
              {
                loading: true,
                success: false,
                error: null,
                localId: action.payload.localId as number,
                progress: 0,
                response: null,
              },
            ], // Add a new item if it doesn't exist
      };
      break;
    case UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS:
      state = {
        ...state,
        uploadAndCreateFlashCard: state.uploadAndCreateFlashCard.map((um) => {
          if (
            um.localId ==
            (action.payload as UploadAndCreateFlashCardResponse).localId
          ) {
            return {
              loading: false,
              success: true,
              error: null,
              localId: um.localId,
              progress: um.progress,
              response: action.payload.response,
            };
          }
          return um;
        }),
        flashCardByLesson: {
          ...state.flashCardByLesson,
          response: [
            ...(state.flashCardByLesson.response as FlashCardDto[]),
            (action.payload as UploadAndCreateFlashCardResponse).flashCard,
          ],
        },
      };
      break;
    case UPLOAD_AND_CREATE_FLASH_CARD_ERROR:
      state = {
        ...state,
        uploadAndCreateFlashCard: state.uploadAndCreateFlashCard.map((um) => {
          if (um.localId == (action.payload as CreateMediaError).localId) {
            return {
              loading: false,
              success: false,
              error: (action.payload as CreateMediaError).error,
              localId: um.localId,
              progress: um.progress,
              response: null,
            };
          }
          return um;
        }),
      };
      break;
    case UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS:
      state = {
        ...state,
        uploadAndCreateFlashCard: state.uploadAndCreateFlashCard.map((um) => {
          if (um.localId == (action.payload as CreateMediaProgress).localId) {
            return {
              loading: true,
              success: false,
              error: null,
              localId: um.localId,
              progress: (action.payload as CreateMediaProgress).progress,
              response: null,
            };
          }
          return um;
        }),
      };
      break;
    case REMOVE_UPLOADED_FLASH_CARD_IMAGE:
      state = {
        ...state,
        uploadAndCreateFlashCard: state.uploadAndCreateFlashCard.filter(
          (um) => um.localId !== action.payload
        ),
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
